import dayjs from "dayjs";
import { getLocationMongoId } from "../../insurance/lib/insuranceSaleApi";

export const getCarLocationMongoId = (car) => {
    if (!car) return undefined;
    const { location } = car;
    if (typeof location === "string" && location) return location;
    if (location && typeof location === "object") {
        return getLocationMongoId(location);
    }
    return car.baseLocationId;
};

export const getReservationPatchIds = (reservation) => {
    const category =
        typeof reservation?.category === "string"
            ? reservation.category
            : reservation?.category?._id || reservation?.category?.id || "";

    const pickupLocation =
        typeof reservation?.pickupLocation === "string"
            ? reservation.pickupLocation
            : getLocationMongoId(reservation?.pickupLocation) || getCarLocationMongoId(reservation?.carSelected) || "";

    return { category, pickupLocation };
};

export const getAlreadyPaidAmount = (reservation) => {
    if (!reservation?.id) return 0;

    const deposit = Number(reservation?.invoice?.deposit);
    if (!Number.isNaN(deposit) && deposit > 0) {
        return Math.max(0, deposit);
    }

    const events = reservation?.invoice?.paymentEvent;
    if (!Array.isArray(events) || events.length === 0) return 0;

    return events.reduce((sum, event) => {
        if (event?.status !== "success") return sum;
        return sum + Math.max(0, Number(event?.amount) || 0);
    }, 0);
};

export const formatStoreDateTime = (value) => {
    if (!value) return "";
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed.format("MM/DD/YYYY HH:mm") : "";
};

export const getAddonRate = (item) => {
    if (item?.pricing?.totalRate != null) return Number(item.pricing.totalRate);
    return Number(item?.rate || 0);
};

export const getReservationPickupLocationId = (reservation) =>
    getCarLocationMongoId(reservation?.carSelected) ||
    (typeof reservation?.pickupLocation === "string"
        ? reservation.pickupLocation
        : getLocationMongoId(reservation?.pickupLocation));
